import React, { useLayoutEffect, useEffect, useRef } from "react";
import "./SearchModeHeader.scss";

// Extracted 1:1 from the previous inline segmented control (same class
// names, same sliding-indicator-via-CSS-vars mechanism) — just moved into
// its own file per the redesign's "no giant component" note. Behavior is
// unchanged: "Все / Люди / Оголошення" still drive the same `activeTab`.
const SearchModeHeader = ({ activeTab, onChange }) => {
  const segRef = useRef(null);
  const allRef = useRef(null);
  const adsRef = useRef(null);
  const usersRef = useRef(null);

  const measureSeg = () => {
    const host = segRef.current;
    if (!host) return;

    const map = { all: allRef.current, ads: adsRef.current, users: usersRef.current };
    const el = map[activeTab];
    if (!el) return;

    const hostRect = host.getBoundingClientRect();
    const btnRect = el.getBoundingClientRect();

    const left = btnRect.left - hostRect.left;
    const width = btnRect.width;

    host.style.setProperty("--seg-left", `${left}px`);
    host.style.setProperty("--seg-width", `${width}px`);
  };

  useLayoutEffect(() => {
    measureSeg();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  useEffect(() => {
    const host = segRef.current;
    if (!host) return;

    let raf = 0;
    const schedule = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => measureSeg());
    };

    const onResize = () => schedule();
    window.addEventListener("resize", onResize);

    const ro = new ResizeObserver(() => schedule());
    ro.observe(host);
    if (allRef.current) ro.observe(allRef.current);
    if (adsRef.current) ro.observe(adsRef.current);
    if (usersRef.current) ro.observe(usersRef.current);

    schedule();

    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
      ro.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="search-mode-header search-mode-header--topbar">
      <div className="tabs-inline segmented search-tabs" data-active={activeTab} ref={segRef}>
        <button
          ref={allRef}
          className={activeTab === "all" ? "active" : ""}
          onClick={() => onChange("all")}
          type="button"
        >
          Все
        </button>
        <button
          ref={adsRef}
          className={activeTab === "ads" ? "active" : ""}
          onClick={() => onChange("ads")}
          type="button"
        >
          Оголошення
        </button>
        <button
          ref={usersRef}
          className={activeTab === "users" ? "active" : ""}
          onClick={() => onChange("users")}
          type="button"
        >
          Люди
        </button>
        <span className="seg-indicator" aria-hidden="true" />
      </div>
    </div>
  );
};

export default SearchModeHeader;
